import type {DocumentQuery} from '@sdox/api'

interface ErrorTypeContentProps {
  data: Extract<DocumentQuery['document'], {__typename: 'ErrorType'}>
}

export const ErrorTypeContent = (props: ErrorTypeContentProps) => {
  const {data} = props
  return (
    <pre>{JSON.stringify(data, null, 2)}</pre>
  )
}
